import axios from "axios";

const COUNSELLOR_AUTH_STORAGE_KEY = "counsellor-login-user";

const getStoredCounsellorUser = () => {
  try {
    const storedCounsellorUser = localStorage.getItem(COUNSELLOR_AUTH_STORAGE_KEY);
    return storedCounsellorUser ? JSON.parse(storedCounsellorUser) : null;
  } catch {
    localStorage.removeItem(COUNSELLOR_AUTH_STORAGE_KEY);
    return null;
  }
};

const counsellorHttpCommon = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

counsellorHttpCommon.interceptors.request.use(
  (config) => {
    const token = config.skipAuth ? null : getStoredCounsellorUser()?.token;

    if (typeof FormData !== "undefined" && config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

counsellorHttpCommon.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(COUNSELLOR_AUTH_STORAGE_KEY);
      window.location.href = "/counsellor-portal/login";
    }

    return Promise.reject(error);
  }
);

export default counsellorHttpCommon;
